/**
 * Font Awesome Icon
 *
 * @author edmsamuel
 */
import React from 'react'

export default function Fa(props) {
  return (
    <i {...props} className={`fa fa-${props.name}`} aria-hidden='true'></i>
  )
}
